import React from 'react';
import './FeaturesCard.css'; // Assuming you have a CSS file to style the card
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function FeaturesCard(props) {
  const { t } = useTranslation();
  const { title, description, image, icon, model, cardclicklink } = props;

  // Ensure model 1 is default by using nullish coalescing
  const imageClassName = `features-card-image features-card-image-model${model ?? 1}`;
  const titleClassName = `features-card-title${model === 2 ? ' features-card-title-model2' : ''}`;

  // Check if icon is provided (React component) or use image (string path)
  const renderImageOrIcon = () => {
    if (icon) {
      const IconComponent = icon;
      return <IconComponent className={imageClassName} />;
    }
    return <img src={image} alt={title} className={imageClassName}></img>;
  };

  // Determine if link is external (starts with http:// or https://)
  const isExternalLink = cardclicklink && (cardclicklink.startsWith('http://') || cardclicklink.startsWith('https://'));

  const cardContent = (
    <>
      {renderImageOrIcon()}
      <div className="features-card-content">
        <h3 className={titleClassName}>{t(title)}</h3>
        <p className="features-card-description">{t(description)}</p>
      </div>
    </>
  );

  // If cardclicklink is provided, wrap content in a link
  if (cardclicklink) {
    if (isExternalLink) {
      return (
        <a 
          href={cardclicklink} 
          target="_blank" 
          rel="noopener noreferrer"
          className="features-card features-card-clickable"
        >
          {cardContent}
        </a>
      );
    } else {
      return (
        <Link 
          to={cardclicklink} 
          className="features-card features-card-clickable"
        >
          {cardContent}
        </Link>
      );
    }
  }

  // If no link, render as regular div
  return (
    <div className="features-card">
      {cardContent}
    </div>
  );
}

export default FeaturesCard;
